export function identify({ email, firstName, lastName, phone, state } = {}) {
  window.analytics.identify("", {
    first_name: firstName,
    last_name: lastName,
    email: email,
    phone: phone,
    state: state,
  });
}

export function applicationStarted({ state } = {}) {
  window.analytics.track("Application Started", {
    state: state,
  });
}

export function applyNowButtonClicked({ siteDivName } = {}) {
  window.analytics.track("Apply Now Button Clicked", {
    site_div_name: siteDivName,
  });
}

export function growthbookExperimentJoined(experiment, result){
  window.analytics.track("Experiment Viewed", {
    experiment: experiment.key,
    variation: result.variationId
  }); 
}

export function callToLearnMoreButtonClicked() {
  window.analytics.track("Call To Learn More Button Clicked", {});
}

export function contactSalesTeamButtonClicked() {
  window.analytics.track("Contact Sales Team Button Clicked", {});
}

export function contactUsButtonClicked({
  buttonCta,
  descriptionText,
  siteDivName,
} = {}) {
  window.analytics.track("Contact Us Button Clicked", {
    button_cta: buttonCta,
    description_text: descriptionText,
    site_div_name: siteDivName,
  });
}

export function downloadOnAppStoreClicked({ appStore } = {}) {
  window.analytics.track("Download On App Store Clicked", {
    app_store: appStore,
  });
}

export function enterpriseLearnMoreButtonClicked({ type } = {}) {
  window.analytics.track("Enterprise Learn More Button Clicked", {
    type: type,
  });
}

export function experienceVideoStarted({ experience, videoName } = {}) {
  window.analytics.track("Experience Video Started", {
    experience: experience,
    video_name: videoName,
  });
}

export function featuredNewsCardClicked({ headline, publication } = {}) {
  window.analytics.track("Featured News Card Clicked", {
    headline: headline,
    publication: publication,
  });
}

export function featuredNewsCardViewed({ headline, publication } = {}) {
  window.analytics.track("Featured News Card Viewed", {
    headline: headline,
    publication: publication,
  });
}

export function learnMoreButtonClicked({
  buttonCta,
  descriptionText,
  headingText,
  serviceType,
  siteDivName,
} = {}) {
  window.analytics.track("Learn More Button Clicked", {
    button_cta: buttonCta,
    description_text: descriptionText,
    heading_text: headingText,
    service_type: serviceType,
    site_div_name: siteDivName,
  });
}

export function mainMenuExpanded() {
  window.analytics.track("Main Menu Expanded", {});
}

export function servicesCardViewed({
  descriptionText,
  headingText,
  serviceType,
} = {}) {
  window.analytics.track("Services Card Viewed", {
    description_text: descriptionText,
    heading_text: headingText,
    service_type: serviceType,
  });
}

export function viewMoreStoriesButtonClicked({ buttonCta, featureStory } = {}) {
  window.analytics.track("View More Stories Button Clicked", {
    button_cta: buttonCta,
    feature_story: featureStory,
  });
}

export function accountCreated() {
  window.analytics.track("Account Created", {});
}

export function phoneNumberSubmitted() {
  window.analytics.track("Phone Number Submitted", {});
}

export function webFlowCompleted() {
  window.analytics.track("Web Flow Completed", {});
}

export function sendError({ message, screen, accountId = "", phoneNumber = "" } = {}) {
  window.analytics.track("Error", { ...{
    toast_message: message,
    screen: screen,
    accountId: accountId,
  },  ...phoneNumber ?? { phoneNumber: phoneNumber } });
}